import React from 'react';
import PropTypes from 'prop-types';
import { Button, CloseWrapper, Stepper, TextInput } from '@tcc/crate';

import { getMessage } from '@tcc/i18n';
import styles from './EditLegend.css';
import { isNumber } from '../../utils/isNumber';

// TODO - Remove SonarQube disablement after BTR-931 is done.
function EditLegend(props) {
  // NOSONAR
  const {
    decrementSteps,
    incrementSteps,
    isFormInvalid,
    legend,
    onCancel,
    onSave,
    setMax,
    setMin,
  } = props;

  if (!legend.steps) {
    return null;
  }

  return (
    <CloseWrapper onRootClose={onCancel}>
      <div className={styles.editPanel} data-test-id="dmb-edit-legend-panel">
        <div className={styles.inputContainer}>
          <div className={styles.editHeader}>{getMessage('editLegend')}</div>
          <div className={styles.stepsContainer}>
            {getMessage('steps')}
            <Stepper
              displayItem={legend.steps}
              onDecrement={decrementSteps}
              onIncrement={incrementSteps}
              testId="dmb-edit-legend-stepper"
            />
          </div>
          <div className={styles.maxMinContainer}>
            <span className={styles.maxMinLabel}>{getMessage('max')}</span>
            <TextInput
              className={styles.maxMinInput}
              error={
                isFormInvalid ||
                legend.maxValue <= 0 ||
                !isNumber(legend.maxValue)
              }
              name="max_value_input"
              onChange={setMax}
              placeholder={legend.maxValue}
              showLabel={false}
              showReset={false}
              testId="dmb-edit-legend-max"
              value={legend.maxValue}
            />
          </div>
          <div className={styles.maxMinContainer}>
            <span className={styles.maxMinLabel}>{getMessage('min')}</span>
            <TextInput
              className={styles.maxMinInput}
              error={
                isFormInvalid ||
                legend.minValue < 0 ||
                !isNumber(legend.minValue)
              }
              name="min_value_input"
              onChange={setMin}
              placeholder={legend.minValue}
              showLabel={false}
              showReset={false}
              testId="dmb-edit-legend-min"
              value={legend.minValue}
            />
          </div>
        </div>
        <div className={styles.buttonContainer}>
          <Button
            className={styles.cancelButton}
            mode="secondary"
            onClick={onCancel}
            testId="dmb-cancel-edit-legend"
          >
            {getMessage('cancel')}
          </Button>
          <Button
            className={styles.saveButton}
            disabled={
              legend.isFetching ||
              isFormInvalid ||
              !isNumber(legend.maxValue) ||
              legend.maxValue <= 0 ||
              !isNumber(legend.minValue) ||
              legend.minValue < 0
            }
            isLoading={legend.isFetching}
            mode="primary"
            onClick={onSave}
            testId="dmb-edit-legend-save-button"
          >
            {getMessage('save')}
          </Button>
        </div>
      </div>
    </CloseWrapper>
  );
}

EditLegend.propTypes = {
  decrementSteps: PropTypes.func,
  incrementSteps: PropTypes.func,
  isFormInvalid: PropTypes.bool,
  legend: PropTypes.object,
  onCancel: PropTypes.func,
  onSave: PropTypes.func,
  setMax: PropTypes.func,
  setMin: PropTypes.func,
};

export default EditLegend;
